import axios from "axios";
import { hostAction } from "./hostSlice";

export const getHostList = (data, from) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("host");
      if (data.data) dispatch(hostAction.setHostList({ hostList: data.data }));
    } catch (e) {
      console.log("e", e);
    }
  };
};
